import React from 'react';
import standInGroup from '../images/home/standInGroup.png';
import Cards from '../components/Cards';
// import Header from '../components/Header';

const About = () => {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: 'smooth',
    });
  }, []);

  return (
    <div>
      <h2 className="bg-gradient-to-b from-enterpriseOrange-500 via-enterpriseOrange-600 to-enterpriseOrange-800 text-white font-montserrat font-bold text-2xl leading-8 pb-4 pt-12 pl-8 md:text-4xl md:leading-10 md:pt-9 md:pl-18 lg:text-5xl lg:leading-14 lg:pb-5 lg:pt-16 lg:pl-24 2xl:text-6xl 2xl:leading-20 2xl:pb-6 2xl:pt-24 2xl:pl-44 3xl:text-7.6xl 3xl:leading-24 3xl:pb-8 3xl:pt-28 3xl:pl-44 uppercase">
        About Techsico Enterprise
      </h2>
      <div className="flex">
        <div className="flex-1">
          <figure className="mt-6 mx-8 md:float-right md:w-60 md:mt-16 md:ml-8 md:mr-14 lg:w-80 lg:h-60 lg:mr-24 lg:mb-12 2xl:w-106 2xl:h-80 2xl:mr-30 3xl:w-192 3xl:h-144">
            <img src={standInGroup} alt="group" className="mb-2" />
            <figcaption className="italic font-montserrat text-techEnter-1000 text-xs mb-6 md:h-14 md:w-60 lg:text-sm lg:w-80 2xl:h-17 2xl:w-106 2xl:text-base 3xl:h-9 3xl:w-192">
              Our team is always ready to help you develop the high quality
              solutions you need.
            </figcaption>
          </figure>
          <p className="flex-grow text-left text-techEnter-1000 font-montserrat text-base mx-8 mt-6 md:text-lg md:mt-16 md:ml-18 md:mr-14 lg:text-xl lg:mt-20 lg:ml-24 lg:w-auto 2xl:text-2xl 2xl:mt-20 2xl:ml-44 2xl:w-192 2xl:h-128 3xl:text-3xl 3xl:w-180 3xl:h-180 3xl:mt-24">
            Techsico was founded in 2001 in Tulsa, OK. Since then, we have grown
            our service area and our number of locations. Our growth has allowed
            us to complete jobs all across the nation as well as internationally
            all while delivering high quality service.
            <br />
            <br />
            Techsico Enterprise is committed to delivering high quality work and
            service to ensure customer satisfaction. We strive to continually
            stay up to date on the latest technologies. Our mission is to
            deliver the highest standards of products and services to ensure
            unmatched customer service every time.
            <br />
            <br />
            {/* todo: check if this works */}
            If it&apos;s technology, it&apos;s Techsico!
          </p>
        </div>
      </div>
      <div>
        <h2 className="font-montserrat text-left text-black font-bold text-3xl h-10 mt-8 mb-6 mx-8 md:w-72 md:h-11 md:ml-18 md:mt-10 md:text-4xl md:mb-7 lg:ml-24 lg:mt-16 2xl:text-5xl 2xl:w-96 2xl:h-14 2xl:ml-44 2xl:mt-12 2xl:mb-5 3xl:text-6xl 3xl:w-128 3xl:h-20 3xl:mt-14 3xl:mb-6">
          Meet the Team
        </h2>
        <Cards />
      </div>
    </div>
  );
};

export default About;
